import { LoopConfig, LoopType } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getLoopTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as LoopConfig;

	return [
		{
			id: 'loop-type',
			selector: '[data-tour="loop-type"]',
			content: 'Required: The type of collection that the task will loop through.',
		},
		...(config.loopType === LoopType.LoopArrayItems
			? [
					{
						id: 'collection-field',
						selector: '[data-tour="collection-field"]',
						content:
							'The collection field/array in the input data that the task should loop through.',
					},
				]
			: []),
		{
			id: 'loop-starting-task',
			selector: '[data-tour="loop-starting-task"]',
			content:
				'The task in the flow that will execute inside of the loop, therefore for each collection item. The Loop Starting Task can also be set by dragging the loop task connector to a task on the task flow diagram view.',
		},
		{
			id: 'result-type',
			selector: '[data-tour="result-type"]',
			content:
				'The format/type in which the result of the task will be displayed in the output data tab. Note: Options vary depending on Loop Type.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
